<template>
  <div class="results-header columns is-mobile" >

    <div class="column" >
      <div class="results-count" v-if="total > 0">
        {{ total }} {{ $t('search_results') }}
      </div>

      <div class="results-count" v-else>
        <span class="is-color-red">0</span> {{ $t('search_results') }}
      </div>

    </div>


    <div class="column has-text-right" >
      <b-button rounded class="filter-button rounded-button-mobile is-large"  @click="$root.$emit('open-filters-mobile')">
        <i class="fa fa-sliders-h"></i>
      </b-button>
      <b-button rounded class="sort-button rounded-button-mobile is-large"  @click="$root.$emit('open-sort-mobile')">
        <i class="fa fa-sort"></i>
      </b-button>
    </div>

  </div>
</template>

<script>
import {mapState} from "vuex";
import FiltersListMobile from "@/components/ResearchBlock/machines/FiltersListMobile";

export default {
  name: "ResultsHeaderMobile",
  computed: {
    ...mapState({
      total: state => state.searchMachines.total,
      filtersList: state => state.searchMachines.filtersList,
      selectedView: state => state.searchMachines.selectedView,
    }),
    sort: {
      get () {
        return this.$store.state.searchMachines.sort
      },
      set (value) {
        this.$root.$emit('select_sort',value)
       // this.$store.commit('searchMachines/setSort', value)
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.results-header {
  flex-direction: row;

  .rounded-button-mobile {
    font-size: 20px;
    border-radius: 100%;
    margin-left:5px;
    width:50px;
    height:47px;
    padding:0;
    display:inline-block;
    font-weight:normal;
  }

  .filter-button {
    background-color: $brand-red;
    border-color: $brand-red;
    color: $white;
  }

  .sort-button {
    background-color: $blackish;
    border-color: $blackish;
    color: $white;
  }
}
</style>